
import React, {Component} from 'react'

class HeaderComponent extends Component 
{
    render()
    {
        return <div style={{paddingTop:'10px', background:'white'}}>
                    
                    <div style={{paddingLeft:'10px', paddingRight:'10px', }}>
                    <table style={{width:'100%'}}>
                        <tr>
                            <td style={{width:'1%', whiteSpace:'nowrap'}}>
                                <div className='window-title' style={{marginRight:'20px'}}>{this.props.title}</div>
                            </td>
                            <td style={{width:'99%'}}>
                                {this.props.children}
                            </td>
                        </tr>
                    </table>
                    </div>
                    <hr style={{marginTop:'10px', marginBottom:'0px', padding:'0px'}}/>
                </div>
    }
}

export default HeaderComponent